import { PageHeader, CTABand } from "./ui-blocks";
import { Reveal } from "./motion";
import { BRAND } from "../data";

export const LegalLayout = ({ overline, title, updated, sections, testid }) => (
  <div data-testid={testid}>
    <PageHeader overline={overline} title={title} subtitle={`Last updated: ${updated}`} />
    <section className="pb-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="space-y-10">
          {sections.map((s, i) => (
            <div key={i} data-testid={`legal-section-${i}`}>
              <h2 className="text-xl sm:text-2xl font-semibold text-white tracking-tight mb-3 flex items-baseline gap-3">
                <span className="font-mono text-sm text-amber-500">{String(i + 1).padStart(2, "0")}</span>
                {s.h}
              </h2>
              {s.p.map((para, j) => (
                <p key={j} className="text-slate-400 leading-relaxed mb-3">{para}</p>
              ))}
              {s.list && (
                <ul className="mt-2 space-y-2">
                  {s.list.map((li, k) => (
                    <li key={k} className="flex gap-3 text-slate-400 leading-relaxed"><span className="text-amber-500 mt-1">•</span><span>{li}</span></li>
                  ))}
                </ul>
              )}
            </div>
          ))}
          <div className="rounded-2xl border border-slate-800/80 bg-[#111827]/60 p-6 text-sm text-slate-400">
            <p className="text-white font-semibold mb-1">Questions?</p>
            <p>Contact us at <a href={`mailto:${BRAND.email}`} className="text-amber-400 hover:underline">{BRAND.email}</a> or {BRAND.phone}.</p>
            <p className="mt-1">{BRAND.name} LLC · {BRAND.address}</p>
          </div>
        </Reveal>
      </div>
    </section>
    <CTABand />
  </div>
);
